import {
  getAppFromPathname,
  type DashboardApp,
} from "@/utils/app-route.utils";

/** Same assets as the app-switcher popup icons. */
const APP_FAVICONS: Record<DashboardApp, string> = {
  accesspoint: "/app-icons/AccessPoint.svg",
  perkpoint: "/app-icons/PerkPoint.svg",
  xpandpoint: "/app-icons/XpandPoint.svg",
  rewardpoint: "/app-icons/RewardPoint.svg",
  giftcard: "/app-icons/GiftCard.svg",
  offers: "/app-icons/Offers.svg",
  gamepoint: "/app-icons/GamePoint.svg",
};

const DEFAULT_FAVICON = "/fevlogo.png";

function faviconType(href: string): string {
  if (href.endsWith(".svg")) return "image/svg+xml";
  if (href.endsWith(".ico")) return "image/x-icon";
  return "image/png";
}

/** Keeps the browser tab favicon in sync with the active dashboard app. */
export function setDocumentFavicon(pathname: string): void {
  const app = getAppFromPathname(pathname);
  const href = (app ? APP_FAVICONS[app] : DEFAULT_FAVICON) || DEFAULT_FAVICON;

  let link = document.querySelector<HTMLLinkElement>("link[rel='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }

  if (link.getAttribute("href") === href) return;

  link.type = faviconType(href);
  link.href = href;
}
